module.exports = "<div>\r\n  <ss-multiselect-dropdown\r\n    name='categories'\r\n    [options]=\"options\"\r\n    [settings]=\"settings\"\r\n    [(ngModel)]=\"data\"\r\n    (ngModelChange)=\"onChange($event)\">\r\n  </ss-multiselect-dropdown>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/+admin/modules/+category/category-multiselect/category-multiselect.component.html
// module id = 1129
// module chunks = 12